document.addEventListener('DOMContentLoaded', function () {
  const categoryMenu = document.querySelector('.category-menu')
  const desktopCategoryMenu = document.querySelector('.desktop-category-menu')
  const backButton = document.querySelector('.back-to-main-menu')
  const subMenus = document.querySelectorAll('.sub-menu')
  const submenuButtons = document.querySelectorAll('.mobile-toggle-submenu')

  // Configuration
  const MOBILE_BREAKPOINT = 1300
  const MENU_DELAY = 300
  const ANIMATION_DURATION = 300
  let isMobile = window.innerWidth < MOBILE_BREAKPOINT

  // State management
  let mobileTimeout
  let desktopTimeout
  let currentEventListeners = []

  // Desktop menu handlers
  const showDesktopMenu = () => {
    clearTimeout(desktopTimeout)
    desktopCategoryMenu.classList.remove('hidden')
  }

  const hideDesktopMenu = () => {
    desktopTimeout = setTimeout(() => {
      desktopCategoryMenu.classList.add('hidden')
    }, MENU_DELAY)
  }

  // Mobile menu handlers
  const showMobileMenu = (e) => {
    if (e) {
      e.preventDefault()
      e.stopPropagation()
    }
    clearTimeout(mobileTimeout)
    categoryMenu.classList.remove('hidden')
  }

  const resetMenus = (event) => {
    if (isMobile) {
      // Only hide the menu if we're clicking the back button
      if (event?.target?.closest('.back-to-main-menu')) {
        categoryMenu.classList.add('hidden')
      }
    } else {
      categoryMenu.classList.add('hidden')
      desktopCategoryMenu.classList.add('hidden')
    }

    // Reset all submenus
    subMenus.forEach((submenu) => {
      submenu.style.display = 'none'
      submenu.classList.remove('active')
    })
    submenuButtons.forEach((button) => {
      button.classList.remove('active')
    })
  }

  const toggleSubmenu = (button, event) => {
    const menuItem = button.closest('li')
    const submenu = menuItem.querySelector('.sub-menu')

    if (submenu) {
      // Prevent event from bubbling up
      event.stopPropagation()

      button.classList.toggle('active')
      if (!submenu.classList.contains('active')) {
        // Close other submenus first
        subMenus.forEach((menu) => {
          if (menu !== submenu) {
            menu.classList.remove('active', 'slide-in')
            menu.style.display = 'none'
            const otherButton = menu.parentElement.querySelector('.mobile-toggle-submenu')
            if (otherButton) otherButton.classList.remove('active')
          }
        })

        submenu.style.display = 'block'
        submenu.offsetHeight // Force reflow
        submenu.classList.add('active', 'slide-in')
      } else {
        submenu.classList.remove('slide-in')
        setTimeout(() => {
          submenu.classList.remove('active')
          submenu.style.display = 'none'
        }, ANIMATION_DURATION)
      }
    }
  }

  // Function to remove all dynamic event listeners
  const removeCurrentEventListeners = () => {
    currentEventListeners.forEach(({ element, event, handler }) => {
      element.removeEventListener(event, handler)
    })
    currentEventListeners = []
  }

  // Function to add event listener and track it
  const addTrackedEventListener = (element, event, handler) => {
    element.addEventListener(event, handler)
    currentEventListeners.push({ element, event, handler })
  }

  // Function to initialize menu handlers based on device type
  const initializeMenuHandlers = (mobile) => {
    // Remove existing dynamic event listeners
    removeCurrentEventListeners()

    const chosenLinks = document.querySelectorAll('.chosen-link')

    if (!mobile) {
      // Desktop handlers
      chosenLinks.forEach((link) => {
        addTrackedEventListener(link, 'mouseover', showDesktopMenu)
        addTrackedEventListener(link, 'mouseleave', hideDesktopMenu)

        const svg = link.querySelector('svg')
        if (svg) {
          addTrackedEventListener(svg, 'click', showDesktopMenu)
        }
      })

      addTrackedEventListener(desktopCategoryMenu, 'mouseover', () => {
        clearTimeout(desktopTimeout)
      })
      addTrackedEventListener(desktopCategoryMenu, 'mouseleave', hideDesktopMenu)
    } else {
      // Mobile handlers
      chosenLinks.forEach((link) => {
        addTrackedEventListener(link, 'click', showMobileMenu)

        const icons = link.querySelectorAll('svg')
        icons.forEach((icon) => {
          addTrackedEventListener(icon, 'click', (e) => {
            showMobileMenu(e)
            e.stopPropagation()
          })
        })
      })
    }
  }

  // Initialize menu handlers for current device type
  initializeMenuHandlers(isMobile)

  // Event Listeners for both mobile and desktop
  submenuButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()
      toggleSubmenu(button, e)
    })
  })

  if (backButton) {
    backButton.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()
      resetMenus(e)
    })
  }

  // Close menu when clicking outside
  document.addEventListener('click', (event) => {
    if (
      !event.target.closest('.category-menu') &&
      !event.target.closest('.chosen-link') &&
      !event.target.closest('.desktop-category-menu')
    ) {
      resetMenus(event)
    }
  })

  // Handle window resize
  window.addEventListener('resize', () => {
    const newIsMobile = window.innerWidth < MOBILE_BREAKPOINT
    if (isMobile !== newIsMobile) {
      resetMenus()
      isMobile = newIsMobile
      initializeMenuHandlers(isMobile)
    }
  })
})
